import { CTA, CTAProps } from '@volkswagen-onehub/components-core';
import { type ReactNode, useState } from 'react';
import TextModal, {
  type TextModalProps,
} from '@/modules/components/TextModal/TextModal';

export type CTAModalProps = {
  modalProps: Omit<TextModalProps, 'closeModal'>;
  children: ReactNode;
  onClick?: () => void;
  openCallback?: () => void;
  closeCallback?: () => void;
} & Omit<CTAProps, 'onClick'>;

const CTAModal = ({
  modalProps,
  children,
  emphasis,
  tag = 'a',
  onClick,
  openCallback,
  closeCallback,
  ...restProps
}: CTAModalProps) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <CTA
        tag={tag}
        emphasis="tertiary"
        onClick={() => {
          setShowModal(!showModal);
          if (onClick) onClick();
        }}
        {...restProps}
      >
        {children}
      </CTA>

      {showModal && (
        <TextModal
          {...modalProps}
          closeModal={() => setShowModal(false)}
          openCallback={openCallback}
          closeCallback={closeCallback}
        />
      )}
    </>
  );
};

export default CTAModal;
